import { slugify } from "../utils/string";

export const ReaderModelEnum = {
   AlphaDigi: 'AlphaDigi',
   Avicam: 'Avicam',
   CtrlID: 'CtrlID',
   Intelbras: 'Intelbras',
   Hikvision: 'Hikvision',
   Positivo: 'Positivo',
   QRCODE: 'QRCODE',
   SEM_PARAR: 'SEM_PARAR',
   Uniview: 'Uniview',
   Weg: 'Weg',
}

export const ReaderModel = {
   AlphaDigi: {
      name: "AlphaDigi",
      imageLight: "/readers/alphadigi_light.png",
      imageDark: "/readers/alphadigi_dark.png",
      key: ReaderModelEnum.AlphaDigi,
   },
   Avicam: {
      name: "Avicam",
      imageLight: "/readers/avicam_light.png",
      imageDark: "/readers/avicam_dark.png",
      key: ReaderModelEnum.Avicam,
   },
   CtrlID: {
      name: "CtrlID",
      imageLight: "/readers/ctrlid_light.png",
      imageDark: "/readers/ctrlid_dark.png",
      key: ReaderModelEnum.CtrlID,
   },
   Intelbras: {
      name: "Dahua/Intelbras",
      imageLight: "/readers/intelbras_light.png",
      imageDark: "/readers/intelbras_dark.png",
      key: ReaderModelEnum.Intelbras,
   },
   Hikvision: {
      name: "Hikvision",
      imageLight: "/readers/hikvision_light.png",
      imageDark: "/readers/hikvision_dark.png",
      key: ReaderModelEnum.Hikvision,
   },
   Positivo: {
      name: "Positivo",
      imageLight: "/readers/positivo_light.png",
      imageDark: "/readers/positivo_dark.png",
      key: ReaderModelEnum.Positivo,
   },
   SEM_PARAR: {
      name: "Sem Parar",
      imageLight: "/readers/semparar_light.png",
      imageDark: "/readers/semparar_dark.png",
      key: ReaderModelEnum.SEM_PARAR,
   },
   Uniview: {
      name: "Uniview",
      imageLight: "/readers/uniview.png",
      imageDark: "/readers/uniview.png",
      key: ReaderModelEnum.Uniview,
   },
   Weg: {
      name: "Weg",
      imageLight: "/readers/weg.png",
      imageDark: "/readers/weg.png",
      key: ReaderModelEnum.Weg,
   },
   QRCODE: {
      name: "QRCODE",
      imageLight: "/readers/qrcode_light.png",
      imageDark: "/readers/qrcode_dark.png",
      key: ReaderModelEnum.QRCODE,
   },
};

export const nonSynchronizableReaders = [
   ReaderModelEnum.QRCODE,
   ReaderModelEnum.SEM_PARAR,
];

export function getReaderModelByEnum(enumValue) {
   return Object.values(ReaderModel).find(value => value.key === enumValue);
}

Object.keys(ReaderModel).map((key) => {
   ReaderModel[key].slug = slugify(ReaderModel[key].name)
});

export const ReaderModelFromSlugs = {
   [slugify(ReaderModel.AlphaDigi.name)]: ReaderModelEnum.AlphaDigi,
   [slugify(ReaderModel.Avicam.name)]: ReaderModelEnum.Avicam,
   [slugify(ReaderModel.CtrlID.name)]: ReaderModelEnum.CtrlID,
   [slugify(ReaderModel.Intelbras.name)]: ReaderModelEnum.Intelbras,
   [slugify(ReaderModel.Hikvision.name)]: ReaderModelEnum.Hikvision,
   [slugify(ReaderModel.Positivo.name)]: ReaderModelEnum.Positivo,
   [slugify(ReaderModel.SEM_PARAR.name)]: ReaderModelEnum.SEM_PARAR,
   [slugify(ReaderModel.Uniview.name)]: ReaderModelEnum.Uniview,
   [slugify(ReaderModel.QRCODE.name)]: ReaderModelEnum.QRCODE,
   [slugify(ReaderModel.Weg.name)]: ReaderModelEnum.Weg,
}

export const WegTypeEnum = {
   LPR: 'LPR',
}

export const WegTypeText = {
   [WegTypeEnum.LPR]: 'LPR',
}

export const AlphadigiTypeEnum = {
   LPR: 'LPR',
   FACIAL: 'FACIAL',
}

export const AvicamTypeEnum = {
   FACIAL: 'FACIAL',
   CAMERA_RF_22812_IP: 'CAMERA_RF_22812_IP',
}

export const CtrlIDTypeEnum = {
   FINGERPRINT: 'FINGERPRINT',
   UHF: 'UHF',
   FACIAL: 'FACIAL',
}

export const CtrlIDAuthenticationTypeEnum = {
   TAG_OR_FINGERPRINT_OR_FACIAL: 'TAG or FINGERPRINT or FACIAL',
   TAG_E_FINGERPRINT: 'TAG e FINGERPRINT',
   FACIAL: 'FACIAL',
   TAG_OR_FACIAL_OR_PASSWORD: 'TAG or FACIAL or PASSWORD',
   TAG_OR_FINGERPRINT_OR_PASSWORD: 'TAG or FINGERPRINT or PASSWORD',
}

export const CtrlIDAuthenticationTypeText = {
   [CtrlIDAuthenticationTypeEnum.FACIAL]: 'Face',
   [CtrlIDAuthenticationTypeEnum.TAG_E_FINGERPRINT]: 'Tag e Digital',
   [CtrlIDAuthenticationTypeEnum.TAG_OR_FACIAL_OR_PASSWORD]: 'Tag ou Face ou Senha',
   [CtrlIDAuthenticationTypeEnum.TAG_OR_FINGERPRINT_OR_FACIAL]: 'Tag ou Digital ou Face',
   [CtrlIDAuthenticationTypeEnum.TAG_OR_FINGERPRINT_OR_PASSWORD]: 'Tag ou Digital ou Senha'
}

export const IntelbrasTagRecordingEnum = {
   PADRAO: 'Padrão',
   REVERSO: 'Reverso',
}

export const IntelbrasTypeEnum = {
   FINGERPRINT_E_TAG: '(FINGERPRINT e TAG)',
   UHF: 'UHF',
   FACIAL: 'FACIAL',
   FACIAL_E_FINGERPRINT: 'FACIAL e FINGERPRINT',
   LPR: 'LPR',
   XPE: 'XPE',
}

export const IntelbrasTypeText = {
   [IntelbrasTypeEnum.FINGERPRINT_E_TAG]: 'Impressão Digital e Tag',
   [IntelbrasTypeEnum.UHF]: 'Antena UHF',
   [IntelbrasTypeEnum.FACIAL]: 'Facial',
   [IntelbrasTypeEnum.FACIAL_E_FINGERPRINT]: 'Facial com Impressão Digital',
   [IntelbrasTypeEnum.LPR]: 'LPR',
   [IntelbrasTypeEnum.XPE]: 'XPE',
}

export const IntelbrasAuthenticationTypeEnum = {
   TAG: 'TAG',
   FACIAL: 'FACIAL',
   TAG_E_FACIAL: 'TAG e FACIAL',
   TAG_OR_FACIAL: 'TAG or FACIAL',
   TAG_E_FINGERPRINT: 'TAG e FINGERPRINT',
   FINGERPRINT_E_FACIAL: 'FINGERPRINT e FACIAL',
   TAG_OR_FINGERPRINT_OR_FACIAL: 'TAG or FINGERPRINT or FACIAL',
   TAG_E_FINGERPRINT_E_FACIAL: 'TAG e FINGERPRINT e FACIAL',
   TAG_OR_FINGERPRINT_OR_FACIAL_OR_PASSWORD: 'TAG or FINGERPRINT or FACIAL or PASSWORD',
   TAG_OR_FACIAL_OR_PASSWORD: 'TAG or FACIAL or PASSWORD',
   TAG_OR_FINGERPRINT_OR_PASSWORD: 'TAG or FINGERPRINT or PASSWORD',
}

export const IntelbrasAuthenticationTypeText = {
   [IntelbrasAuthenticationTypeEnum.TAG]: 'Tag',
   [IntelbrasAuthenticationTypeEnum.FACIAL]: 'Face',
   [IntelbrasAuthenticationTypeEnum.TAG_E_FACIAL]: 'Tag e Face',
   [IntelbrasAuthenticationTypeEnum.TAG_OR_FACIAL]: 'Tag ou Face',
   [IntelbrasAuthenticationTypeEnum.TAG_E_FINGERPRINT]: 'Tag e Digital',
   [IntelbrasAuthenticationTypeEnum.FINGERPRINT_E_FACIAL]: 'Digital e Face',
   [IntelbrasAuthenticationTypeEnum.TAG_OR_FINGERPRINT_OR_FACIAL]: 'Tag ou Digital ou Face',
   [IntelbrasAuthenticationTypeEnum.TAG_E_FINGERPRINT_E_FACIAL]: 'Tag e Digital e Face',
   [IntelbrasAuthenticationTypeEnum.TAG_OR_FINGERPRINT_OR_FACIAL_OR_PASSWORD]: 'Tag ou Digital ou Face ou Senha',
   [IntelbrasAuthenticationTypeEnum.TAG_OR_FACIAL_OR_PASSWORD]: 'Tag ou Face ou Senha',
   [IntelbrasAuthenticationTypeEnum.TAG_OR_FINGERPRINT_OR_PASSWORD]: 'Tag ou Digital ou Senha',
}

export const HikvisionTypeEnum = {
   FINGERPRINT: 'FINGERPRINT',
   FACIAL: 'FACIAL',
   LPR: 'LPR',
}

export const HikvisionTypeText = {
   [HikvisionTypeEnum.FINGERPRINT]: 'Impressão Digital',
   [HikvisionTypeEnum.FACIAL]: 'Facial',
   [HikvisionTypeEnum.LPR]: 'LPR',
}

export const HikvisionTimeoutActionEnum = {
   BLOCK: 'Block',
   RELEASE: 'Release',
}

export const HikvisionTimeoutActionText = {
   [HikvisionTimeoutActionEnum.BLOCK]: 'Bloquear',
   [HikvisionTimeoutActionEnum.RELEASE]: 'Liberar',
}

export const HikvisionNtpAddressTypeEnum = {
   DOMAIN: 'domain',
   IP: 'ip',
}

export const HikvisionNtpAddressTypeText = {
   [HikvisionNtpAddressTypeEnum.DOMAIN]: 'Domínio',
   [HikvisionNtpAddressTypeEnum.IP]: 'IP'
}

export const HikvisionAuthenticationType = {
   TAG_OR_FINGERPRINT_OR_FACIAL: 'TAG or FINGERPRINT or FACIAL',
   TAG_E_FINGERPRINT: 'TAG e FINGERPRINT',
   TAG_E_FACIAL: 'TAG e FACIAL',
   FINGERPRINT_FACIAL: 'FINGERPRINT, FACIAL',
   TAG_FINGERPRINT_FACIAL: 'TAG, FINGERPRINT, FACIAL',
   TAG_OR_FACIAL: 'TAG or FACIAL',
   FACIAL: 'FACIAL',
}

export const HikvisionAuthenticationTypeText = {
   [HikvisionAuthenticationType.TAG_OR_FINGERPRINT_OR_FACIAL]: 'Tag ou Digital ou Face',
   [HikvisionAuthenticationType.TAG_E_FINGERPRINT]: 'Tag e Digital',
   [HikvisionAuthenticationType.TAG_E_FACIAL]: 'Tag e Face',
   [HikvisionAuthenticationType.FINGERPRINT_FACIAL]: 'Digital e Face',
   [HikvisionAuthenticationType.TAG_FINGERPRINT_FACIAL]: 'Tag e Digital e Face',
   [HikvisionAuthenticationType.TAG_OR_FACIAL]: 'Tag ou Face',
   [HikvisionAuthenticationType.FACIAL]: 'Face',
}

export const PositivoTypeEnum = {
   FINGERPRINT: 'FINGERPRINT',
   FACIAL: 'FACIAL',
}

export const PositivoTypeText = {
   [PositivoTypeEnum.FINGERPRINT]: 'Impressão Digital',
   [PositivoTypeEnum.FACIAL]: 'Facial',
}

export const PositivoAuthenticationTypeEnum = {
   TAG_OR_FINGERPRINT_FACIAL: 'TAG or FINGERPRINT or FACIAL',
   TAG_DIGITAL: 'TAG e FINGERPRINT',
   FACIAL: 'FACIAL',
   TAG_OR_FACIAL_OR_PASSWORD: 'TAG or FACIAL or PASSWORD',
   TAG_OR_FINGERPRINT_PASSWORD: 'TAG or FINGERPRINT or PASSWORD',
}

export const PositivoAuthenticationTypeText = {
   [PositivoAuthenticationTypeEnum.TAG_OR_FINGERPRINT_FACIAL]: 'Tag ou Digital ou Face',
   [PositivoAuthenticationTypeEnum.TAG_DIGITAL]: 'Tag e Digital',
   [PositivoAuthenticationTypeEnum.FACIAL]: 'Face',
   [PositivoAuthenticationTypeEnum.TAG_OR_FACIAL_OR_PASSWORD]: 'Tag ou Face ou Senha',
   [PositivoAuthenticationTypeEnum.TAG_OR_FINGERPRINT_PASSWORD]: 'Tag ou Digital ou Senha',
}

export const QRCODEModelEnum = {
   SOBREPOR: 'Sobrepor',
   EMBUTIR: 'Embutir',
}

export const QRCODEModelText = {
   [QRCODEModelEnum.SOBREPOR]: 'Sobrepor',
   [QRCODEModelEnum.EMBUTIR]: 'Embutir',
}

export const ReaderCredentialType = {
   PASWORD: 1,
   PANIC_PASSWORD: 2,
   TAG: 3,
   TAG_SEM_PARAR: 4,
   FACE: 5,
}